<template>
<div>
    <section class="page-title" style="background-color:#e2f1f2;">
    <div class="center servidor">
      <v-layout row wrap align-center>
        <v-flex xs12 sm12 lg6>
       <p class="label-planos">Soluções para</p>
        <h1 class="the-title"><span>Soluções</span> para Servidor</h1>
        <p>O sorriso do Servidor Público faz parte dos nossos Planos!</p>
        <a @click="scrollToClass('.list-planos')" class="button-contrate">Contratar Agora</a>
        </v-flex>               
       
</v-layout>
</div>
</section>

<section class="page-content center">
    <v-layout row wrap>
    <v-flex xs12 sm12 lg12>
    <p class="title-label">O seu sorriso é o nosso diferencial</p>
    <p>Servidor RO, Aproveite a oportunidade de levar saúde bucal de qualidade para você e sua família com desconto em folha de pagamento</p>
    </v-flex>

    <v-flex xs12 sm12 lg7>
    <p class="title-label">Acesso à rede credenciada</p>
    <p>Para acessar a rede credenciada, <a href="http://www.primavida.com.br/redecredenciada" target="_blank">clique aqui.</a></p>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <br>
    <p class="title-label">Quem pode aderir ao Plano?</p>
    <ul>Dependentes:</ul>
    <li>Pai / Padrasto</li>
    <li>Mãe / Madrasta</li>
    <li>Filhos / Enteados</li>
    <li>Cônjuge / Companheiro</li>
    <br>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <br>
    <p class="title-label">Principais Vantagens</p>
    <!-- <p>A Primavida tem planos atrativos, flexíveis e acessíveis para você e sua família, confira:</p> -->
    <li>Credenciamento de dentista por indicação</li>
    <li>Inclusão de dependentes e agregados</li>
    <li>Autorização de tratamentos on-line</li>
    <li>Abrangência Grupo de Municípios RJ</li>
    <li>Sem limites para utilização</li>
    <li>Aplicativo para celular</li>
    <br>
    </v-flex>

    
    <v-flex xs12 sm12 lg12>
    <br>
    <p class="title-label">App PrimaVida Beneficiário</p>    
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_android.png" width="120px"><br>
    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg5>
    <img src="../Content/images/app_apple.png" width="120px"><br>
    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
    </v-flex>
    
    </v-layout>
    <br>
    <p class="title-label">Principais Coberturas (Rol da ANS)</p>
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico);</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
    </div>
<v-layout row wrap justify-center style="background-color:#e2f1f2;">
    <v-flex xs12 sm12 lg4>
        <div class="planos-wrapper">
        <div class="list-planos">                    
            <div class="item">
                <h6 class="dePara">De</h6>
                <p class="priceOld"><span>R$</span> 45,00<br></p>
                <h6 class="dePara">Por</h6>
                <p class="price"><span>R$</span> 28,50<br><span>(Por pessoa)</span></p>
                <h6 class="desconto">Desconto especial de R$ 16,50</h6>
                <p class="cobertura">
                    <span>
                        <p class="cobertura" ><span style="font-weight: bold;color: #F57C00;background-color: #FFF3E0;">SERVIDOR ESTADUAL RO</span><b>INDIVIDUAL/FAMILIAR</b></p>
                    </span>
                </p>
                <div class="boleto"><i class="fas fa-barcode"></i>CLÁSSICO RO SERVIDOR</div>
                <a @click="openDialog(plano,planoEstadual)" class="button">Contratar plano</a>
            </div>
        </div>
        </div>
        </v-flex>  

    <v-flex xs12 sm12 lg4>
        <div class="planos-wrapper">
        <div class="list-planos">                    
            <div class="item">
                <h6 class="dePara">De</h6>
                <p class="priceOld"><span>R$</span> 45,00<br></p>
                <h6 class="dePara">Por</h6>
                <p class="price"><span>R$</span> 28,50<br><span>(Por pessoa)</span></p>
                <h6 class="desconto">Desconto especial de R$ 16,50</h6>
                <p class="cobertura">
                    <span>
                        <p class="cobertura"><span style="font-weight: bold;color: #455A64;background-color: #ECEFF1;">SERVIDOR MUNICIPAL RO</span><b>INDIVIDUAL/FAMILIAR</b></p>
                    </span>
                </p>
                <div class="boleto"><i class="fas fa-barcode"></i>CLÁSSICO RO SERVIDOR</div>
                <a @click="openDialog(plano,planoMunicipal)" class="button">Contratar plano</a>
            </div>
        </div>
        </div>
    </v-flex>

    <v-flex xs12 sm12 lg4>
        <div class="planos-wrapper">
        <div class="list-planos">                    
            <div class="item">
                <h6 class="dePara">De</h6>
                <p class="priceOld"><span>R$</span> 45,00<br></p>
                <h6 class="dePara">Por</h6>
                <p class="price"><span>R$</span> 28,50<br><span>(Por pessoa)</span></p>
                <h6 class="desconto">Desconto especial de R$ 16,50</h6>
                <p class="cobertura">
                    <span>
                        <p class="cobertura"><span style="font-weight: bold;color: #009b9b;background-color: #dbe9e9;">SERVIDOR FEDERAL RO</span><b>INDIVIDUAL/FAMILIAR</b></p>
                    </span>
                </p>
                <div class="boleto"><i class="fas fa-barcode"></i>CLÁSSICO RO SERVIDOR</div>
                <a @click="openDialog(plano,planoFederal)" class="button">Contratar plano</a>
            </div>
        </div>
        </div>
    </v-flex>
</v-layout>
</section>
<v-dialog v-model="dialog" max-width="650px" max-height="400px"> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) beneficiário(a),</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#009B99"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
              </v-checkbox>
              <v-text-field
                v-if="contrataccept"
                v-model="cpf"
                label="Informe seu CPF"
                v-validate="'required|cpf'"
                :error-messages="errors.collect('cpf')"
                return-masked-value mask="###.###.###-##"
                data-vv-name="cpf"
                :keyup="validaCPF()"
                outline
            ></v-text-field>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn :disabled="!continua" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'https://ecommerce.primavida.com.br/'+tipoContrato+'?plano='+planoSelecionado+'&cpf='+cpf+'&orgaoaverbador='+orgaoAverbador+'&vendedor=jaqueline-santos&competencia='+competencia+''">Continuar</v-btn>
              <v-btn color="red darken-1" depressed style="border-radius: 8px; width: 130px;color: white;" @click="close">Cancelar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
import CpfValidate from '../components/validators/rules/cpf'
/* import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global' */
export default {
    components: {Snackbar},
     data(){
        return{  
                plano: '5eea91713046722c2418d236',
                planoEstadual: 'Estadual',
                planoMunicipal: 'Municipal',
                planoFederal: 'Federal',
                competencia: '',
                planoSelecionado: '',
                orgaoAverbador: '5f5a652695144524fb9381ed',               
                contrataccept: false, 
                dialog: false,
                cpf: '',
                tipoContrato: '',
                continua: false,
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()
        //this.carregaDados()

    },
     watch: {
        dialog(val) {
        val || this.close()
      }
     },
    methods: {
        openDialog(plano,tipoPlano){
            this.dialog = true
            this.planoSelecionado = plano
            if(tipoPlano == 'Estadual')
            {
            this.tipoContrato = 'contratosp'
            this.competencia = 'estadual'
            }
            else
            if(tipoPlano == 'Municipal')
            {
            this.tipoContrato = 'contratopf'
            this.competencia = 'municipal'
            }
            else
            if(tipoPlano == 'Federal')
            {
            this.tipoContrato = 'contratopf'
            this.competencia = 'federal'
            }

        },
        scrollToClass(className) {
            // Get the first element with the given class name
            let el = this.$el.querySelector(className)
            // Get the bounding rectangle so we can get the element position position
            let rect = el.getBoundingClientRect()
            // Scroll to the element (using x and y axis)
            window.scrollTo(rect.left, rect.top)
            },

        validaCPF()
        {
            if(CpfValidate(this.cpf))
            {
            this.continua = true
            sessionStorage.setItem('orgaoAverbadorId','5f5a652695144524fb9381ed')                        
            }
            else
            this.continua = false
        },

        close(){
            this.dialog = false
            this.continua = false
            this.contrataccept = false
            this.cpf = ''
        }
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .imagemcaarj{
        background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
        background-size: 500px;
    }
</style>